import * as NavigationActions from './actions';

const initialState = {
  previousPathname: null
}

const navigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case NavigationActions.NAVIGATION_CHANGE_PAGE: {
      return {
        ...state,
        previousPathname: action.previousPathname
      }
    }
    default: {
      return state;
    }
  }
}

export default navigationReducer;
